import { ViewService } from '../models'

export const copyService = (service: ViewService): Omit<ViewService, 'id'> => {
  const copyService: ViewService = {
    ...service,
    name: `${service.name} (Kopie)`,
    order: -1, // Reset order so backend assigns next available order
    categories: service.categories.map((category) => ({ ...category })),
  }
  return copyService
}
